import { useState } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Button, Form, Modal } from "react-bootstrap";
import { Maker, saveMaker } from "../../api/tooling";
import { ErrorNotice } from "./ToolingShared";

export default function MakerForm({
  maker,
  onClose,
}: {
  maker?: Maker;
  onClose: () => void;
}) {
  const client = useQueryClient();
  const [name, setName] = useState(maker?.name || "");
  const [color, setColor] = useState(maker?.color || "#3574c5");
  const mutation = useMutation({
    mutationFn: () => saveMaker({ name, color }, maker?.id),
    onSuccess: async () => {
      await client.invalidateQueries({ queryKey: ["tooling"] });
      onClose();
    },
  });
  return (
    <Modal
      show
      onHide={() => !mutation.isLoading && onClose()}
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title>{maker ? "Edit Die Maker" : "Add Die Maker"}</Modal.Title>
      </Modal.Header>
      <Form
        onSubmit={(e) => {
          e.preventDefault();
          mutation.mutate();
        }}
      >
        <Modal.Body>
          <ErrorNotice error={mutation.error} />
          <Form.Group className="mb-3" controlId="maker-name">
            <Form.Label>Operator name</Form.Label>
            <Form.Control
              required
              maxLength={100}
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </Form.Group>
          <Form.Group controlId="maker-color">
            <Form.Label>Color</Form.Label>
            <Form.Control
              type="color"
              value={color}
              onChange={(e) => setColor(e.target.value)}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            disabled={mutation.isLoading}
            onClick={onClose}
          >
            Cancel
          </Button>
          <Button type="submit" disabled={mutation.isLoading || !name.trim()}>
            {mutation.isLoading ? "Saving…" : "Save die maker"}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}
